/* Caramì language polish — removes legacy mixed-language UI on commerce pages. */
(function(){
  if(window.__caramiLanguagePolish) return;
  window.__caramiLanguagePolish=true;
  var lang=(document.documentElement.lang||'it').toLowerCase().slice(0,2);

  function replaceExactText(root,map){
    if(!root||!map)return;
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    var nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(function(node){
      var raw=node.nodeValue||'';var trimmed=raw.trim();if(!trimmed)return;
      Object.keys(map).forEach(function(from){if(trimmed===from)node.nodeValue=raw.replace(trimmed,map[from]);});
    });
  }

  function removeLegacyEnglishBoilerplate(){
    if(lang!=='en')return;
    var root=document.querySelector('.carami-product-info__raw-description');if(!root)return;
    var bad=[
      'the luxury lingerie of caramì macthes elegance and comfort',
      'the luxury lingerie of carami macthes elegance and comfort',
      'refined and classy underwear with high-quality and entirely made in italy products',
      'bras, brazilian briefs, culottes and bodysuits',
      'among the loungewear there are elegant silk velvet pajamas and kimonos',
      'the activewear includes leggings, shorts and sports bras'
    ];
    Array.from(root.querySelectorAll('p,div,li')).forEach(function(el){
      if(!el.isConnected)return;var text=(el.textContent||'').toLowerCase().replace(/\s+/g,' ').trim();
      if(bad.some(function(fragment){return text===fragment||text.indexOf(fragment)>-1;}))el.remove();
    });
  }

  function polish(){
    if(lang==='en'){
      replaceExactText(document,{
        'Tessuti pregiati':'Premium fabrics',
        'Reso Facile':'Easy exchanges',
        'recensioni verificate':'verified reviews',
        'Potrebbe piacerti anche':'You may also like',
        'Delivery & returns':'Shipping & returns'
      });
      document.querySelectorAll('.carami-product-info__summary span:first-child').forEach(function(el){if(el.textContent.trim()==='Delivery & returns')el.textContent='Shipping & returns';});
      removeLegacyEnglishBoilerplate();
    }else if(lang==='fr'){
      replaceExactText(document,{
        'Tessuti pregiati':'Matières d’exception',
        'Reso Facile':'Échanges faciles',
        'recensioni verificate':'avis vérifiés',
        'Potrebbe piacerti anche':'Vous aimerez peut-être aussi'
      });
    }
  }

  function init(){polish();setTimeout(polish,250);setTimeout(polish,900);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
